import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { CloudForwarderInputsMetrics } from "@graylog/enterprise-api";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const POLL_INTERVAL_MS = 6e4;
export const compositeIdFor = ({ input_id, forwarder_node_id }) => `${input_id}:${forwarder_node_id}`;
export const fetchForwarderInputMetrics = (compositeIds, fields) => CloudForwarderInputsMetrics.getMetrics(compositeIds, fields);
const sortedUnique = (values) => Array.from(new Set(values)).sort();
const useForwarderInputMetrics = (pairs, fields) => {
  var _a;
  const stableIds = sortedUnique(pairs.map(compositeIdFor));
  const stableFields = sortedUnique(fields);
  const enabled = stableIds.length > 0 && stableFields.length > 0;
  const { data, isInitialLoading, isError } = useQuery({
    queryKey: ["forwarder", "inputs", "metrics", stableIds, stableFields],
    queryFn: () => defaultOnError(
      fetchForwarderInputMetrics(stableIds, stableFields),
      i18n.t("notifications.load_input_metrics_failed", { ns: "enterprise_forwarder" }),
      i18n.t("notifications.load_input_metrics_failed_title", { ns: "enterprise_forwarder" })
    ),
    enabled,
    placeholderData: keepPreviousData,
    refetchInterval: POLL_INTERVAL_MS
  });
  return {
    metricsByPair: (_a = data == null ? void 0 : data.metrics) != null ? _a : {},
    isInitialLoading,
    isError
  };
};
export default useForwarderInputMetrics;
